import { createAction } from '@reduxjs/toolkit';
import { GetSidebarMenuItemsResponse } from 'features/sidebar/api/types';

export const sidebarActions = {
  getSidebarMenuItemsRequest: createAction(
    '[sidebar]GET_SIDEBAR_MENU_ITEMS_REQUEST'
  ),
  getSidebarMenuItemsSuccess: createAction<GetSidebarMenuItemsResponse>(
    '[sidebar]GET_SIDEBAR_MENU_ITEMS_SUCCESS'
  ),
  getSidebarMenuItemsFailure: createAction<string[]>(
    '[sidebar]GET_SIDEBAR_MENU_ITEMS_FAILURE'
  ),
};
